import { memo } from 'react';

/**
 * Reusable Button Component
 * Memoized to prevent unnecessary re-renders
 */

const BUTTON_VARIANTS = {
  primary: 'bg-green-500 hover:bg-green-600',
  secondary: 'bg-gray-500 hover:bg-gray-600',
  danger: 'bg-red-500 hover:bg-red-600',
};

const BUTTON_SIZES = {
  sm: 'py-2 px-4 text-base',
  md: 'py-3 px-6 text-xl',
  lg: 'py-4 px-8 text-2xl',
};

const Button = memo(function Button({
  children,
  onClick,
  disabled = false,
  variant = 'primary',
  size = 'md',
  className = '',
  fullWidth = false,
}) {
  const baseStyles = 'text-white font-bold rounded-2xl transition-all transform hover:scale-105 disabled:bg-gray-400 disabled:cursor-not-allowed disabled:transform-none';
  const variantStyles = BUTTON_VARIANTS[variant] || BUTTON_VARIANTS.primary;
  const sizeStyles = BUTTON_SIZES[size] || BUTTON_SIZES.md;
  const widthStyles = fullWidth ? 'w-full' : '';

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${variantStyles} ${sizeStyles} ${widthStyles} ${className}`}
    >
      {children}
    </button>
  );
});

export default Button;
